import React from "react";

export default function Section12() {
  const services = [
    {
      title: "  Engaging Websites That Convert",
      description: `Our experienced New York web designers build websites designed to convert visitors into customers. With clean layouts, intuitive navigation, and optimized calls-to-action, every page encourages engagement and sales. Fully responsive design ensures smooth performance on mobile, tablet, and desktop devices.`,
    },
    {
      title: "Scalable Websites for Growing Brands",
      description: `Growing businesses need websites that can handle more traffic, content, and features. We build structured, high-performance solutions that scale effortlessly, keeping your site fast, secure, and efficient while supporting long-term growth.`,
    },
  ];

  return (
    <div className="w-full Section11">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        

        <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
          {services.map((service, index) => (
            <div
              key={index}
              className={`${index % 2 === 0 ? "bg-[#E42E35] text-white" : "bg-[#f5f5f5] text-[#373737]"} p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%] rounded-[8px]`}
            >
              <h3 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                {service.title}
              </h3>
              <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
                {service.description}
              </p>
              
            </div>
          ))}
          
        </div>
      </div>
      <div className="w-[90%] md:w-[85%] mx-auto mt-24">
  <div className="bg-[#F9F9F9] rounded-[16px] py-14 px-6 md:px-12 shadow-sm">

    <h3 className="text-center text-[22px] md:text-[28px] font-bold text-black mb-3">
      Our <span className="text-[#DA2128]">Achievements</span>
    </h3>

    <p className="text-center text-[#666] text-[14px] md:text-[16px] mb-12 max-w-[620px] mx-auto">
      Recognized by leading platforms, partners, and global technology ecosystems.
    </p>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-center place-items-center">

      <img
        src="/assets/go-awards-logo 1.png"
        alt="Go Global Awards"
        className="max-h-[100px] transition-all duration-300"
      />

      <img
        src="/assets/fastest-growing-brand-award-of-2021 1.png"
        alt="Fastest growing brand"
        className="max-h-[100px] transition-all duration-300"
      />

      <img
        src="/assets/shopify-experts.png"
        alt="Shopify Experts"
        className="max-h-[100px] transition-all duration-300"
      />
    </div>
  </div>
</div>
    </div>
    
  );
}
